import styled from 'styled-components';

export const EmailRow = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
`

export const PassRow = styled.div`
  margin-top: 28px;
  display: flex;
  flex-direction: column;
`

export const PassRefRow = styled.div`
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
`

export const BtnRow = styled.div`
  margin-top: 39px;
  display: flex;
  flex-direction: column;
`

export const WarningRow = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
`